import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
import {GetUserInfo,GetUserLoginStatus} from '@/apis/user'
const store = new Vuex.Store({
    state:{
        isUserInfoReady:false,
        userData:{},
        userid: 0 ,//116810(kunpark)/117911(yugutou22)
        apptoken:''
    },
    mutations:{
        updateUserState(state,data){
            state.userid = data.userid
            state.apptoken = data.apptoken
        },
        updateUserData(state,data){
          state.userData = data
          state.isUserInfoReady = true
        }
    },
    actions:{
      getUserData(store){

        /**获取用户信息 */
        GetUserInfo().then(res=>{

            if(res.result){
                let data = res.data[0];
                let hash = Math.ceil(Math.random()*99999999999);
                data.userFace = `/uploadfiles/avatar/${store.state.userid}.jpg?${hash}`;
                store.commit('updateUserData',data)

            }else{
              store.commit('updateUserData',{})
            }

        })

      }
    }
})

/**
 * 有userid时返回
 */
store.created = function(callback){
    if(this.state.userid && this.state.apptoken){
        typeof callback === 'function' && callback(this.state.userid,this.state.apptoken)
    }else{
        setTimeout(()=>{
            this.created(callback)
        },100)
    }
}

/**
 * 添加ready事件
 */
store.ready = function(callback){
    if(this.state.isUserInfoReady){
        callback(this.state)
    }else{
        setTimeout(()=>{
            this.ready(callback)
        },100)
    }
}



GetUserLoginStatus().then(res=>{
	if(res.islogin == 'true'){
		store.commit('updateUserState',{
			userid:res.userid,
			apptoken:res.apptoken
    })

    store.dispatch('getUserData')
	}
})


export default store



// WEBPACK FOOTER //
// ./src/store/index.js